import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Modal, Row } from 'react-bootstrap'
import { Book, Eye } from 'react-bootstrap-icons'
import toast from 'react-hot-toast'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import Cookies from 'js-cookie'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { FaArrowLeft, FaEdit, FaRemoveFormat, FaTrash } from 'react-icons/fa'
import axios from 'axios'
import DeleteEnrolledCourse from './DeleteEnrolledCourse'
import { Table,Tbody, Td, Th, Thead, Tr } from 'react-super-responsive-table'
import { useAuth } from './AuthContext'

const EnrolledCourses = () => {
  const {token} = useAuth()
  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const location = useLocation()
  const { id } = useParams()
  console.log('studentId', id)

  const studentName = location.state?.student_name
  const studentAdmissionNumber = location.state?.admission_number
  const student_id = location.state?.student_id || id

  console.log('ENR. STUDENT ID:', student_id)
  const initialData = []
  const [studentCount, setStudentCount] = useState(null)
  const [countColor, setCountColor] = useState('') // Add color for the response

  const [data, setData] = useState(initialData)
  const [newEnroll, setNewEnroll] = useState({
    student_id: student_id,
    course_id: '',
    class_id: '',
    enroll_date: '',
  })

  const navigate = useNavigate()
  const [showModal, setShowModal] = useState(false)
  const [user, setUser] = useState(null)
  const [courses, setCourses] = useState([])
  const [classes, setClasses] = useState([])
  const [loading, setLoading] = useState(false)
  const [selectedNewCourse, setSelectedNewCourse] = useState([])
  const [courseTouched, setCourseTouched] = useState(false)
  const [originalClassId, setOriginalClassId] = useState(null)
  const [deleteModal, setDeleteModal] = useState(false)
  const [selectedStudentId, setSelectedStudentId] = useState(null)
  const [selectedCourseId, setSelectedCourseId] = useState(null)
  const [selectedCoursename, setSelectedCoursename] = useState(null)

  const [studentDetails, setStudentDetails] = useState({
    name: '',
    admission_number: '',
  })

  console.log('STUDENT DETAILS:', studentDetails)
  const [showEditModal, setShowEditModal] = useState(false)
  const [editFormData, setEditFormData] = useState({
    student_id: '',
    course_id: '',
    class_id: '',
    enroll_date: '',
  })

  useEffect(() => {
    ApiEndpoints.getAllClasses().then((res) => setClasses(res.data.data))
    ApiEndpoints.getAllCourses().then((res) => setCourses(res.data.data))
  }, [])

  useEffect(() => {
    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    let token = null
    console.log('InstituteID', institueId)

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
        console.log('TOKEN:', token)
      } catch (err) {
        console.error(' Failed to parse user cookie', err)
      }
    } else {
      console.warn('user cookie not found')
    }

    const fetchFilteredData = async () => {
      console.log('Insti ID: ', institueId)
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          institute_id: Number(institueId),
        }

        console.log('Request Headers:', headers)

        const response = await axios.get(
          BASE_URL+'/student/all',
          { headers },
        )
        const students = response.data.data
        const matchedStudent = students.find(
          (std) => std.id === Number(student_id),
        )
        if (matchedStudent) {
          setStudentDetails({
            name: matchedStudent.name,
            admission_number: matchedStudent.admission_number,
          })
        } else {
          console.error('Student not found')
        }
      } catch (error) {
        console.error(error.response?.data?.message || 'Something went wrong')
      }
    }

    if (student_id) {
      fetchFilteredData()
    }
  }, [student_id])

  useEffect(() => {
    const fetchEnrolled = async () => {
      try {
        const response = await axios.get(
          BASE_URL+'/get/student/all/enroll',
          {
            params: { student_id },
            headers:{
              Authorization: `Bearer ${token}`
            }
          },
        )
        console.log('RESPONSE: ', response)
        setData(response.data.data)
      } catch (error) {
        console.error(error.response?.data?.resul)
      }
    }
    fetchEnrolled()
  }, [loading])

  const handleEditEnroll = (
    student_id,
    course_id,
    currentClassId,
    enroll_date,
  ) => {
    let formattedDate = ''
    if (enroll_date) {
      const dateObj = new Date(enroll_date)
      if (!isNaN(dateObj)) {
        formattedDate = dateObj.toISOString().split('T')[0] // "YYYY-MM-DD"
      }
    }
    setOriginalClassId(currentClassId)
    setEditFormData({
      student_id,
      course_id,
      class_id: currentClassId,
      enroll_date: formattedDate,
    })
    setShowEditModal(true)
  }

  const handleUpdateClass = async () => {
    try {
      const token = JSON.parse(Cookies.get('user'))?.token
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }

      let payload = {
        student_id: Number(editFormData.student_id),
        course_id: Number(editFormData.course_id),
        class_id: Number(editFormData.class_id),
      }

      const classChanged = editFormData.class_id !== originalClassId
      const enrollDateChanged = !!editFormData.enroll_date

      if (classChanged && enrollDateChanged) {
        payload.class_id = Number(editFormData.class_id)
        payload.enroll_date = editFormData.enroll_date
      } else if (enrollDateChanged && !classChanged) {
        payload.class_id = null
        payload.enroll_date = editFormData.enroll_date
      }

      const response = await axios.put(
        BASE_URL+'/student/class/change',
        payload,
        { headers },
      )

      toast.success(response.data.message || 'Class updated successfully')
      setShowEditModal(false)
      setLoading(!loading) // Refresh enrolled data
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to update class')
    }
  }

  const handleNavigateToCreateClass = () => {
    navigate('/AddClass')
  }

  const handleBack = () => {
    navigate(`/StudentProfile/${student_id}`)
  }
  const handleCourseChange = (e) => {
    const courseId = e.target.value
    console.log('Selected course Id:', courseId)
    setCourseTouched(true)
    setSelectedNewCourse(courseId)
    setNewEnroll((prev) => ({ ...prev, course_id: courseId }))
    // setClasses([])
    setStudentCount(null)
    console.log('Cleared Classes')

    if (courseId) {
      ApiEndpoints.getAllClassesByCourseId(courseId)
        .then((res) => {
          const { data } = res
          if (data.status === false || !data.data?.length) {
            toast.error('No classes found for this course.')
            setClasses([])
            setStudentCount(null)
          } else {
            setClasses(data.data)
          }
        })
        .catch((error) => {
          // This is where 404 or other errors come
          if (
            error.response?.data?.message === 'No classes found for this course'
          ) {
            // toast.error('No classes found for this course.')
            setStudentCount(null)
          } else {
            console.error('Error fetching classes:', error)
            toast.error('Something went wrong while fetching classes.')
          }
          setClasses([])
          setStudentCount(null)
        })
    }
  }

  const handleClassChange = (e) => {
    const classId = e.target.value
    setNewEnroll((prev) => ({ ...prev, class_id: classId }))

    setEditFormData((prev) => ({ ...prev, class_id: classId }))

    // Clear previous student count
    setStudentCount(null)
    setCountColor('')

    if (classId) {
      // Call the API to get the student count for the selected class
      
      fetch(
        BASE_URL+`/get/class/student/count?class_id=${classId}`,{
        headers :
          {
          Authorization: `Bearer ${token}`
        }
      } 
      )
        .then((response) => response.json())
        .then((data) => {
          if (
            data?.status &&
            data?.data?.current !== undefined &&
            data?.data?.maximum_limit !== undefined
          ) {
            const current = data.data.current === null ? 0 : data.data.current // Treat null as 0
            const maximum_limit = parseInt(data.data.maximum_limit, 10) // Parse maximum_limit as a number
            setStudentCount({ current, maximum_limit }) // Set the state with correct property names
            setCountColor('green') // Example color for success
          } else {
            setStudentCount('No data available')
            setCountColor('red') // Example color for no data
          }
        })
        .catch((error) => {
          console.error('Error fetching student count:', error)
          setStudentCount('Error fetching data')
          setCountColor('red') // Example color for error
        })
    }
  }

  useEffect(() => {
    const userLogged = Cookies.get('user')
    console.log('userLogged', userLogged)
    if (userLogged) {
      try {
        setUser(JSON.parse(userLogged))
        console.log('User:', JSON.parse(userLogged))
      } catch (error) {
        console.error('Error parsing user data:', error)
        Cookies.remove('user')
      }
    }
  }, [])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setNewEnroll((prev) => ({ ...prev, [name]: value }))
  }
  const handleSave = async (e) => {
    e.preventDefault()
    try {
      setLoading(true)
      const institueId = Cookies.get('institute_id')
      console.log('INSTITUTE ID', institueId)

      const payload = {
        student_id: student_id,
        course_id: parseInt(newEnroll.course_id),
        class_id: parseInt(newEnroll.class_id),
        enroll_date: new Date().toISOString().split('T')[0],
      }
      const response = await axios.post(
        BASE_URL+'/student/course/enroll',
        payload,{
          headers:{
            Authorization: `Bearer ${token}`
          }
       }
      )
      console.log('Sending Response: ', response)

      setNewEnroll(response)
      // setNewCourse({ course_name: '', duration: '', fee: '', description: '' })

      toast.success(response.data.message)
      setShowModal(false)
    } catch (error) {
      toast.error(error.response?.data?.result || 'Something went wrong.')
      setShowModal(false)
    } finally {
      setLoading(false)
    }
  }

  const handleViewFees = (student_id, course_id, class_id) => {
    navigate(`/ManageStudentFees/${student_id}/${course_id}/${class_id}`)
    console.log('Student ID:', student_id)
    console.log('Course ID:', course_id)
    console.log('Class ID:', class_id)
  }

  const handleDeleteEnroll = (studentId, courseId, courseName) => {
    setSelectedStudentId(studentId)
    setSelectedCourseId(courseId)
    setSelectedCoursename(courseName)
    setDeleteModal(true)
  }

  const handleConfirmDelete = () => {
    setData((prevData) =>
      prevData.filter(
        (item) =>
          !(
            item.student_id === selectedStudentId &&
            item.course_id === selectedCourseId
          ),
      ),
    )
    console.log('Deleting:', selectedStudentId, selectedCourseId)
    // Call your delete API here
    setDeleteModal(false)
  }

  return (
    <>
      <style>
        {`
          .blinking-link {
            color: blue;
            text-decoration: none;
            cursor: pointer;
            animation: blink 1s infinite;
            font-weight:bold;
          }

          @keyframes blink {
            0% { color: blue; }
            50% { color: red; }
            100% { color: blue; }
          }

      `}
      </style>
      <div style={{ marginLeft }}>
        {/* Header */}

        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 768 ? '55px' : '-12px',
          }}
        >
            <div
          className="container-fluid p-0"
          style={{ marginTop: window.innerWidth < 768 ? '55px' : '-12px' }}
        >
          {/* <div className="bg-secondary p-4 rounded d-flex flex-wrap justify-content-between align-items-center text-white"> */}
          <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
            <h2 className="m-0">
              Enrolled Courses for{' '}
              <span style={{ color: 'orange', fontWeight: 'bold' }}>
                {(studentName || studentDetails?.name)
                  ?.charAt(0)
                  .toUpperCase() +
                  (studentName || studentDetails?.name)?.slice(1)}
              </span>
              {(studentAdmissionNumber || studentDetails?.admission_number) &&
                (studentName || studentDetails?.name) &&
                ' - '}
              <span style={{ color: 'orange', fontWeight: 'bold' }}>
                {studentAdmissionNumber || studentDetails?.admission_number}
              </span>
            </h2>
            {/* {user?.user_type !== 'teacher' && ( */}
            <Button
              variant="light"
              className="fw-bold"
              onClick={() => setShowModal(true)}
            >
              <Book
                size={16}
                className="me-2 fw-bold"
                style={{ verticalAlign: 'middle' }}
              />
              <span
                style={{ verticalAlign: 'middle' }}
                onClick={() => setShowModal(true)}
              >
                Enrolled New Course
              </span>
            </Button>
            {/* )} */}
          </div>
        </div>
        </div>
        <div className="text-start mt-4">
          <Row>
            <Col>
               {user?.user_type === 'admin'&& ( 
              <Button onClick={() => navigate('/AddStudent')}>
                <FaArrowLeft /> Go to Student List
              </Button>
              )} 
               {user?.user_type === 'teacher'  && ( 
              <Button onClick={() => navigate('/TeacherStudent')}>
                <FaArrowLeft /> Go to Student List
              </Button>
              )} 
            </Col>
            <Col className="d-flex justify-content-end">
              {user?.user_type !== 'teacher' && (
                <Button onClick={handleBack}>
                  Go to{' '}
                  <span className="fw-bold">
                    {(studentName || studentDetails?.name)
                      ?.charAt(0)
                      .toUpperCase() +
                      (studentName || studentDetails?.name)?.slice(1)}{' '}
                  </span>{' '}
                  profile
                </Button>
              )}
            </Col>
          </Row>
        </div>
          <Table className="table table-striped table-bordered table-hover rounded overflow-hidden shadow-sm mb-0 mt-4">
            <Thead className="bg-dark text-white">
              <Tr>
                <Th>Course Name</Th>
              <Th>Class Name</Th>
              <Th>Enrolled Date</Th>
              <Th>Action</Th>
            </Tr>
          </Thead>

          <Tbody>
            {/* Display data rows only if data exists */}
            {data.length > 0 &&
              data.map((item, index) => (
                <Tr key={index}>
                  <Td>{item.course ? item.course.name : 'N/A'}</Td>
                  <Td>{item.class ? item.class.class_name : 'N/A'}</Td>

                  <Td>
                    {item.enroll_date
                      ? new Date(item.enroll_date).toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: 'long',
                          year: 'numeric',
                        })
                      : 'N/A'}{' '}
                  </Td>
                  <Td>
                    <div className="d-flex flex-wrap justify-content-start justify-content-md-center gap-2">
                      {/* {user?.user_type !== 'teacher' && (
                        <Button
                          variant="info"
                          onClick={() =>
                            handleViewFees(
                              item.student_id,
                              item.course.id,
                              item.class.id,
                            )
                          }
                          title="View Fees"
                        >
                          <Eye />
                        </Button>
                      )} */}
                      <Button
                        variant="warning"
                        title="Edit Enrolled Course"
                        onClick={() =>
                          handleEditEnroll(
                            item.student_id,
                            item.course_id,
                            item.class_id,
                          )
                        }
                      >
                        <FaEdit />
                      </Button>
                      {user?.user_type !== 'teacher' && (
                        <Button
                          variant="danger"
                          title="Delete Enrolled Course"
                          onClick={() =>
                            handleDeleteEnroll(
                              item.student_id,
                              item.course_id,
                              item.course?.name,
                            )
                          }
                        >
                          <FaTrash />
                        </Button>
                      )}
                    </div>
                  </Td>
                </Tr>
              ))}
          </Tbody>
        </Table>
        <DeleteEnrolledCourse
          show={deleteModal}
          onHide={() => setDeleteModal(false)}
          onConfirm={handleConfirmDelete}
          studentId={selectedStudentId}
          courseId={selectedCourseId}
          courseName={selectedCoursename}
          studentName={
            ((studentName || studentDetails?.name)?.charAt(0).toUpperCase() ||
              '') + (studentName || studentDetails?.name)?.slice(1)
          }
        />
        <Modal
          size="lg"
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
        >
          <Modal.Header closeButton className="bg-secondary text-white">
            <Modal.Title>Enrolled New Course</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSave}>
              {/* Course Name */}
              <Form.Group className="mb-3">
                <Form.Label>Course *</Form.Label>
                <Form.Select
                  name="course_id"
                  value={selectedNewCourse}
                  onChange={handleCourseChange}
                  required
                >
                  <option value="">Select Course</option>
                  {courses.map((course) => (
                    <option key={course.id} value={course.id}>
                      {course.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              {/* Duration */}

              {classes.length === 0 && selectedNewCourse && (
                <p style={{ color: 'red', letterSpacing: '1px' }}>
                  The selected course has no class. Please{' '}
                  <span
                    className="blinking-link"
                    onClick={handleNavigateToCreateClass}
                  >
                    click here
                  </span>{' '}
                  to create new class.
                </p>
              )}

              <Form.Group className="mb-3">
                <Form.Label>Class *</Form.Label>
                <Form.Select
                  name="class_id"
                  value={newEnroll.class_id}
                  onChange={handleClassChange}
                  disabled={!courseTouched || classes.length === 0}
                >
                  <option value="">Select Class</option>
                  {classes.map((clas) => (
                    <option key={clas.id} value={clas.id}>
                      {clas.class_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              {studentCount !== null && studentCount !== 'No data available' && (
                <div
                  style={{
                    color: countColor,
                    marginBottom: '5px',
                    fontWeight: 'bold',
                    letterSpacing: '1px',
                  }}
                >
                  {studentCount.current === null
                    ? `There are still ${studentCount.maximum_limit} seats available in this class.`
                    : studentCount.current === studentCount.maximum_limit
                    ? 'There are no more seats available in this class.'
                    : `There are ${
                        studentCount.maximum_limit - studentCount.current
                      } seats left in this class.`}
                </div>
              )}

              <Form.Group className="mb-3">
                <Form.Label>Enrolled Date</Form.Label>
                <Form.Control
                  type="date"
                  name="enroll_date"
                  value={newEnroll.enroll_date}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>

              <Modal.Footer>
                <Button variant="danger" onClick={() => setShowModal(false)}>
                  Cancel
                </Button>
                <Button variant="success" type="submit">
                  Save Enrolled Course
                </Button>
              </Modal.Footer>
            </Form>
          </Modal.Body>
        </Modal>
        <Modal
          show={showEditModal}
          onHide={() => setShowEditModal(false)}
          centered
          size="lg"
        >
          <Modal.Header closeButton className="bg-warning text-dark">
            <Modal.Title>Edit Enrolled Course</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group controlId="formCourseName">
                <Form.Label>Course</Form.Label>
                <Form.Control
                  type="text"
                  value={
                    courses.find((c) => c.id === editFormData.course_id)
                      ?.name || ''
                  }
                  disabled={!courseTouched || classes.length === 0}
                />
              </Form.Group>

              <Form.Group controlId="formClassSelect">
                <Form.Label>Select New Class</Form.Label>
                <Form.Select
                  value={editFormData.class_id}
                  onChange={handleClassChange}
                >
                  <option value="">Select Class</option>
                  {classes
                    .filter((cls) => cls.course_id === editFormData.course_id)
                    .map((cls) => (
                      <option key={cls.id} value={cls.id}>
                        {cls.class_name}
                      </option>
                    ))}
                </Form.Select>
              </Form.Group>

              {studentCount !== null && studentCount !== 'No data available' && (
                <div
                  style={{
                    color: countColor,
                    marginBottom: '5px',
                    fontWeight: 'bold',
                    letterSpacing: '1px',
                  }}
                >
                  {studentCount.current === null
                    ? `There are still ${studentCount.maximum_limit} seats available in this class.`
                    : studentCount.current === studentCount.maximum_limit
                    ? 'There are no more seats available in this class.'
                    : `There are ${
                        studentCount.maximum_limit - studentCount.current
                      } seats left in this class.`}
                </div>
              )}

              {user?.user_type !== 'teacher' && (
                <Form.Group className="mb-3">
                  <Form.Label>Enrolled Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="enroll_date"
                    value={editFormData.enroll_date || ''}
                    onChange={(e) =>
                      setEditFormData({
                        ...editFormData,
                        enroll_date: e.target.value,
                      })
                    }
                  />
                </Form.Group>
              )}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowEditModal(false)}>
              Cancel
            </Button>
            <Button variant="warning" onClick={handleUpdateClass}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  )
}
export default EnrolledCourses
